module.exports = __webpack_public_path__ + "static/media/arrowRightMenu.70000634.svg";